import { observer } from 'mobx-react';
import { ProductLicenseOverview } from '../../../Types';
import { L, T } from '../../../../../../Translations';

interface Props {
  license: ProductLicenseOverview;
}

function LicenseStatusStartOnDisplay({ license }: Props) {
  switch (license.licenseKind) {
    case 'past':
    case 'active':
      return (
        <T
          kind="Starts <date/>"
          date={<L localizeable={license.startOn} format="short-month-day-year" />}
        />
      );
    case 'future':
      return (
        <T
          kind="Starts <date/> (<span>{{count}} days from now</span>)"
          date={<L localizeable={license.startOn} format="short-month-day-year" />}
          span={(content) => <span className="text-amber-600">{content}</span>}
          count={license.daysFromNow}
        />
      );
  }
}
export default observer(LicenseStatusStartOnDisplay);
